import * as t from "io-ts";

export const PageType = t.keyof({
  "text_multiple_choice": null,
  "list_single_choice": null,
  "icon_multiple_choice": null,
  "input": null,
  "opt-in": null,
});
export type PageType = t.TypeOf<typeof PageType>;
